// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VirtualTable-Container {
  --vt-row-height: 4.5rem;
  --vt-border-radius: 0.63rem;
  --vt-header-background: var(--bs-secondary-subtle);
  --vt-background: linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3)), linear-gradient(110.72deg, rgba(255, 255, 255, 0.24) 1.21%, rgba(196, 196, 196, 0.04) 100%);
  --vt-header-shadow: 1.05469px 2.10938px 2.10938px 0px rgba(0, 0, 0, 0.15);
  --vt-cell-padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  --vt-item-border: 1px solid rgba(0, 0, 0, 0.25);
  --vt-nested-orphan-background: rgba(219, 227, 255, 0.64);
  --vt-alternate-shading: rgba(197, 197, 197, 0.2);
  --vt-expanded-shading: rgba(0, 0, 0, 0.08);
  --vt-expanded-background: #f9f6f4;
  --vt-header-height: 3.75rem;
  --vt-expanded-inner-shadow: -0.15rem 0.1rem 1rem -0.5rem rgb(0, 0, 0) inset;
}
.VirtualTable-Container .VirtualTable.condensed {
  --vt-row-height: 3.8rem;
}
.VirtualTable-Container {
  --vt-row-color-dep: rgb(255, 255, 255);
  --vt-row-color-arr: rgb(242, 242, 242);
  --vt-row-color-spl: rgb(207, 231, 255);
  --vt-row-color-late: rgb(234, 243, 191);
  --vt-row-color-late-arr: rgb(255, 220, 220);
  --vt-row-color-deleted: rgb(255, 255, 255);
  --vt-row-color-cancelled: rgb(255, 216, 177);
  --vt-row-color-curbside: rgb(255, 220, 220);
}
.VirtualTable-Container.DynamicRows *:not(.VirtualTable-Header) > .VirtualTable-List > .VirtualTable-Item > .VirtualTable-Row {
  min-height: var(--vt-row-height);
}
.VirtualTable-Container.DynamicRows *:not(.VirtualTable-Header) > .VirtualTable-List > .VirtualTable-Item > .VirtualTable-Row .VirtualTable-Cell {
  height: inherit;
}
.VirtualTable-Container.DynamicRows {
  --vt-row-height: inherit;
}

.VirtualTable-Container {
  position: relative;
  width: 100%;
  height: 100%;
  font-weight: 700;
}
.VirtualTable-Container .VirtualTable {
  width: 100%;
  background: var(--vt-background);
  backdrop-filter: blur(15.5172px);
  -webkit-backdrop-filter: blur(15.5172px);
  -moz-backdrop-filter: blur(15.5172px);
  transform: translate3d(0, 0, 0);
  overflow: hidden;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item {
  position: relative;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell {
  flex-grow: 1;
  border-width: 1px 0 0 1px;
  border-color: #e4e4e4;
  border-style: solid;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell > span {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell .Select {
  background: transparent !important;
  border: none !important;
  padding-right: var(--bs-btn-padding-x) !important;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell .Select span {
  color: #000 !important;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell .Select:after {
  display: none;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell [role=button] {
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Expand,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Select {
  position: relative;
  height: inherit;
  padding: var(--vt-cell-padding);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell.alternate,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Expand.alternate,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Select.alternate {
  background-color: var(--vt-alternate-shading);
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell.alternate + .alternate,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Expand.alternate + .alternate,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Select.alternate + .alternate {
  border-left-color: transparent !important;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Cell,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Expand,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Select {
  overflow: hidden;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Expand,
.VirtualTable-Container .VirtualTable .VirtualTable-Item .VirtualTable-Select {
  position: relative;
  text-align: center;
  width: calc(var(--vt-row-height) / 1.25);
  flex-grow: 0;
  border-width: 1px 0 0 0;
  border-color: #e4e4e4;
  border-style: solid;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Item + .VirtualTable-Item,
.VirtualTable-Container .VirtualTable .VirtualTable-Item + .VirtualTable-Row,
.VirtualTable-Container .VirtualTable .VirtualTable-Row + .VirtualTable-Item,
.VirtualTable-Container .VirtualTable .VirtualTable-Row + .VirtualTable-Row {
  margin-top: -1px;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Header {
  position: relative;
  background-color: var(--vt-header-background);
  box-shadow: var(--vt-header-shadow);
  z-index: 11 !important;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Header .VirtualTable-Cell .VirtualTable-CellContent {
  display: flex;
  gap: 0.5rem;
  text-align: inherit;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Header .VirtualTable-Cell,
.VirtualTable-Container .VirtualTable .VirtualTable-Header .VirtualTable-Expand,
.VirtualTable-Container .VirtualTable .VirtualTable-Header .VirtualTable-Select {
  text-transform: uppercase;
  height: var(--vt-header-height);
  overflow: hidden;
  margin-top: -1px;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Header .VirtualTable-Expand input[type=checkbox] {
  border-color: #fff;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Expand,
.VirtualTable-Container .VirtualTable .VirtualTable-Select {
  background-color: #fff !important;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Expand input[type=checkbox],
.VirtualTable-Container .VirtualTable .VirtualTable-Select input[type=checkbox] {
  margin: 0.1rem 0 0 0;
  z-index: 1;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Expanded {
  position: relative;
}
.VirtualTable-Container .VirtualTable .VirtualTable-Expanded:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}
.VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-List > .VirtualTable-Item > .VirtualTable-Row.expanded {
  background-color: var(--vt-expanded-background);
}
.VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-Row {
  position: relative;
}
.VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-Row:after {
  content: "";
  position: absolute;
  pointer-events: none;
  display: block;
  width: 100%;
  height: calc(100% - 1px);
  top: 0;
  left: 0;
  border-radius: var(--vt-border-radius);
  z-index: 1;
  border-width: 4px;
  border-style: solid;
  border-color: transparent;
  pointer-events: none;
}
.VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-Row:hover:after, .VirtualTable-Container .VirtualTable > *:not(.VirtualTable-Header) .VirtualTable-Row.selected:after {
  border-color: var(--bs-secondary);
}
.VirtualTable-Container .VirtualTable-Select,
.VirtualTable-Container .VirtualTable-Expand {
  background-color: #fff;
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox],
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox] {
  transform: scale(1.25);
  box-shadow: none !important;
  background-color: transparent !important;
  border: 0 !important;
  overflow: visible;
  --bs-form-check-bg-image: transparent;
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox]:before,
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:before {
  position: absolute;
  margin: 1px 0 0 0;
  font-family: "Skyvibe-Icon-Font-Set" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox]:checked:before,
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:checked:before {
  color: #fff;
  background-color: var(--bs-warning);
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox]:disabled:before,
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:disabled:before {
  opacity: 0.65;
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox]:not(:checked):before {
  content: "\\e98d";
}
.VirtualTable-Container .VirtualTable-Select input[type=checkbox]:checked:before {
  content: "\\e934";
  padding: 0.25rem;
  font-size: 0.5rem;
  border-radius: 2px;
  font-weight: 900;
}
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:not(:checked):before {
  content: "\\e98e";
}
.VirtualTable-Container .VirtualTable-Expand input[type=checkbox]:checked:before {
  content: "\\e98f";
}
.VirtualTable-Container .VirtualTable-Controls {
  position: absolute;
  top: 1rem;
  right: -3.25rem;
  height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}
.VirtualTable-Container .VirtualTable-Controls i {
  transform: scale(1.25);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).DEP {
  background-color: var(--vt-row-color-dep);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).ARR {
  background-color: var(--vt-row-color-arr);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).LATE {
  background-color: var(--vt-row-color-late);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).LATE.ARR.CURRENT {
  background-color: var(--vt-row-color-late-arr);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).SPL {
  background-color: var(--vt-row-color-spl);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).DELETED {
  background-color: var(--vt-row-color-deleted);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).DELETED:before {
  content: "";
  width: calc(100% - 8px);
  height: 0.31rem;
  background-color: var(--bs-secondary-subtle);
  opacity: 0.8;
  position: absolute;
  top: calc(50% - 0.155rem);
  left: 4px;
  z-index: 1;
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).DEP.UPCOMING:not(.DELETED, .CANCELLED, .COMPLETED) .UNASSIGNED {
  animation: pulse 1s ease-in-out infinite !important;
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).CANCELLED {
  background-color: var(--vt-row-color-cancelled);
}
.VirtualTable-Container .VirtualTable-Row:not(.HEADER).CURBSIDE {
  background-color: var(--vt-row-color-curbside);
}`, "",{"version":3,"sources":["webpack://./src/components/VirtualTable/styles.scss"],"names":[],"mappings":"AAyBA;EACE,uBAAA;EACA,2BAAA;EACA,kDAAA;EACA,uLAAA;EACA,yEAAA;EACA,8CAAA;EACA,+CAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,iCAAA;EACA,2BAAA;EACA,2EAAA;AAxBF;AAyBE;EACE,uBAAA;AAvBJ;AAQA;EAiBE,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,2CAAA;EACA,0CAAA;EACA,4CAAA;EACA,2CAAA;AAtBF;AA2BU;EACE,gCAAA;AAzBZ;AA0BY;EACE,eAAA;AAxBd;AAiBE;EAaE,wBAAA;AA3BJ;;AA+BA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA5BF;AA6BE;EACE,WAAA;EACA,gCAAA;EACA,gCAAA;EACA,wCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AA3BJ;AA4BI;EACE,kBAAA;AA1BN;AA2BM;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAzBR;AA0BQ;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;AAxBV;AA0BQ;EACE,kCAAA;EACA,uBAAA;EACA,iDAAA;AAxBV;AAyBU;EACE,sBAAA;AAvBZ;AAyBU;EACE,aAAA;AAvBZ;AA2BQ;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;AAzBV;AA4BM;;;EAGE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA1BR;AA2BQ;;;EACE,6CAAA;AAvBV;AAwBU;;;EACE,yCAAA;AApBZ;AAQM;;;EAeE,gBAAA;AAlBR;AAoBM;;EAEE,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAlBR;AAwBM;;;;EAEE,gBAAA;AApBR;AAuBI;EACE,kBAAA;EACA,6CAAA;EACA,mCAAA;EACA,sBAAA;AArBN;AAuBQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AArBV;AAwBM;;;EAGE,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;AAtBR;AAyBQ;EACE,kBAAA;AAvBV;AA2BI;;EAEE,iCAAA;AAzBN;AA0BM;;EACE,oBAAA;EACA,UAAA;AAvBR;AA0BI;EACE,kBAAA;AAxBN;AAyBM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;AAvBR;AA4BQ;EACE,+CAAA;AA1BV;AA6BM;EACE,kBAAA;AA3BR;AA4BQ;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,WAAA;EACA,wBAAA;EACA,MAAA;EACA,OAAA;EACA,sCAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA1BV;AA4BQ;EAEE,iCAAA;AA3BV;AAgCE;;EAEE,sBAAA;AA9BJ;AA+BI;;EACE,sBAAA;EACA,2BAAA;EACA,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;AA5BN;AA6BM;;EACE,kBAAA;EACA,iBAAA;EACA,+CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;AA1BR;AA6BQ;;EACE,WAAA;EACA,mCAAA;AA1BV;AA8BQ;;EACE,aAAA;AA3BV;AAmCQ;EACE,gBAAA;AAjCV;AAqCQ;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAnCV;AA2CQ;EACE,gBAAA;AAzCV;AA6CQ;EACE,gBAAA;AA3CV;AAgDE;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,UAAA;AA9CJ;AA+CI;EACE,sBAAA;AA7CN;AAiDI;EACE,yCAAA;AA/CN;AAiDI;EACE,yCAAA;AA/CN;AAiDI;EACE,0CAAA;AA/CN;AAiDI;EACE,8CAAA;AA/CN;AAiDI;EACE,yCAAA;AA/CN;AAiDI;EACE,6CAAA;AA/CN;AAgDM;EACE,WAAA;EACA,uBAAA;EACA,eAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AA9CR;AAkDM;EACE,mDAAA;AAhDR;AAmDI;EACE,+CAAA;AAjDN;AAmDI;EACE,8CAAA;AAjDN","sourcesContent":["$RowHeight: 4.5rem;\n$BorderRadius: 0.63rem;\n$HeaderBackground: var(--bs-secondary-subtle);\n$Background:\n  linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.3)),\n  linear-gradient(110.72deg, rgba(255, 255, 255, 0.24) 1.21%, rgba(196, 196, 196, 0.04) 100%);\n$HeaderShadow: 1.05469px 2.10938px 2.10938px 0px rgba(0, 0, 0, 0.15);\n$CellPadding: 0.5rem 0.5rem 0.5rem 0.5rem;\n$ItemBorder: 1px solid rgba(0, 0, 0, 0.25);\n$NestedOrphanBackground: rgba(219, 227, 255, 0.64);\n$AlternateShading: rgba(197, 197, 197, 0.2);\n$ExpandedShading: rgba(0, 0, 0, 0.08);\n$ExpandedBackground: #f9f6f4;\n$HeaderHeight: 3.75rem;\n$ExpandedInnerShadow: -0.15rem 0.1rem 1rem -0.5rem rgba(0, 0, 0, 1) inset;\n\n$RowColor_DEP: rgba(255, 255, 255, 1); // WHITE\n$RowColor_ARR: rgba(242, 242, 242, 1); // GREY\n$RowColor_SPL: rgba(207, 231, 255, 1); // BLUE\n$RowColor_LATE: rgba(234, 243, 191, 1); // DARKER LIGHT GREEN\n$RowColor_LATE_ARR: rgba(255, 220, 220, 1); // LIGHT RED\n$RowColor_DELETED: rgba(255, 255, 255, 1); // WHITE\n$RowColor_CANCELLED: rgba(255, 216, 177, 1); // ORANGE\n$RowColor_CURBSIDE: rgba(255, 220, 220, 1); // LIGHT RED\n\n.VirtualTable-Container {\n  --vt-row-height: #{$RowHeight};\n  --vt-border-radius: #{$BorderRadius};\n  --vt-header-background: #{$HeaderBackground};\n  --vt-background: #{$Background};\n  --vt-header-shadow: #{$HeaderShadow};\n  --vt-cell-padding: #{$CellPadding};\n  --vt-item-border: #{$ItemBorder};\n  --vt-nested-orphan-background: #{$NestedOrphanBackground};\n  --vt-alternate-shading: #{$AlternateShading};\n  --vt-expanded-shading: #{$ExpandedShading};\n  --vt-expanded-background: #{$ExpandedBackground};\n  --vt-header-height: #{$HeaderHeight};\n  --vt-expanded-inner-shadow: #{$ExpandedInnerShadow};\n  .VirtualTable.condensed {\n    --vt-row-height: 3.8rem;\n  }\n  --vt-row-color-dep: #{$RowColor_DEP};\n  --vt-row-color-arr: #{$RowColor_ARR};\n  --vt-row-color-spl: #{$RowColor_SPL};\n  --vt-row-color-late: #{$RowColor_LATE};\n  --vt-row-color-late-arr: #{$RowColor_LATE_ARR};\n  --vt-row-color-deleted: #{$RowColor_DELETED};\n  --vt-row-color-cancelled: #{$RowColor_CANCELLED};\n  --vt-row-color-curbside: #{$RowColor_CURBSIDE};\n  &.DynamicRows {\n    *:not(.VirtualTable-Header) {\n      > .VirtualTable-List {\n        > .VirtualTable-Item {\n          > .VirtualTable-Row {\n            min-height: var(--vt-row-height);\n            .VirtualTable-Cell {\n              height: inherit;\n            }\n          }\n        }\n      }\n    }\n    --vt-row-height: inherit;\n  }\n}\n\n.VirtualTable-Container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  font-weight: 700;\n  .VirtualTable {\n    width: 100%;\n    background: var(--vt-background);\n    backdrop-filter: blur(15.5172px);\n    -webkit-backdrop-filter: blur(15.5172px);\n    -moz-backdrop-filter: blur(15.5172px);\n    transform: translate3d(0, 0, 0);\n    overflow: hidden;\n    .VirtualTable-Item {\n      position: relative;\n      .VirtualTable-Cell {\n        flex-grow: 1;\n        border-width: 1px 0 0 1px;\n        border-color: #e4e4e4;\n        border-style: solid;\n        > span {\n          display: block;\n          width: 100%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n        .Select {\n          background: transparent !important;\n          border: none !important;\n          padding-right: var(--bs-btn-padding-x) !important;\n          span {\n            color: #000 !important;\n          }\n          &:after {\n            display: none;\n          }\n        }\n        // ellipses overflow\n        [role='button'] {\n          white-space: pre-wrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n      .VirtualTable-Cell,\n      .VirtualTable-Expand,\n      .VirtualTable-Select {\n        position: relative;\n        height: inherit;\n        padding: var(--vt-cell-padding);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        &.alternate {\n          background-color: var(--vt-alternate-shading);\n          + .alternate {\n            border-left-color: transparent !important;\n          }\n        }\n        overflow: hidden;\n      }\n      .VirtualTable-Expand,\n      .VirtualTable-Select {\n        position: relative;\n        text-align: center;\n        width: calc(var(--vt-row-height) / 1.25);\n        flex-grow: 0;\n        border-width: 1px 0 0 0;\n        border-color: #e4e4e4;\n        border-style: solid;\n      }\n    }\n\n    .VirtualTable-Item,\n    .VirtualTable-Row {\n      + .VirtualTable-Item,\n      + .VirtualTable-Row {\n        margin-top: -1px;\n      }\n    }\n    .VirtualTable-Header {\n      position: relative;\n      background-color: var(--vt-header-background);\n      box-shadow: var(--vt-header-shadow);\n      z-index: 11 !important; // +1 greater than badges\n      .VirtualTable-Cell {\n        .VirtualTable-CellContent {\n          display: flex;\n          gap: 0.5rem;\n          text-align: inherit;\n        }\n      }\n      .VirtualTable-Cell,\n      .VirtualTable-Expand,\n      .VirtualTable-Select {\n        text-transform: uppercase;\n        height: var(--vt-header-height);\n        overflow: hidden;\n        margin-top: -1px;\n      }\n      .VirtualTable-Expand {\n        input[type='checkbox'] {\n          border-color: #fff;\n        }\n      }\n    }\n    .VirtualTable-Expand,\n    .VirtualTable-Select {\n      background-color: #fff !important;\n      input[type='checkbox'] {\n        margin: 0.1rem 0 0 0;\n        z-index: 1;\n      }\n    }\n    .VirtualTable-Expanded {\n      position: relative;\n      &:before {\n        content: '';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        pointer-events: none;\n      }\n    }\n    > *:not(.VirtualTable-Header) {\n      .VirtualTable-List > .VirtualTable-Item > .VirtualTable-Row {\n        &.expanded {\n          background-color: var(--vt-expanded-background);\n        }\n      }\n      .VirtualTable-Row {\n        position: relative;\n        &:after {\n          content: '';\n          position: absolute;\n          pointer-events: none;\n          display: block;\n          width: 100%;\n          height: calc(100% - 1px);\n          top: 0;\n          left: 0;\n          border-radius: var(--vt-border-radius);\n          z-index: 1;\n          border-width: 4px;\n          border-style: solid;\n          border-color: transparent;\n          pointer-events: none;\n        }\n        &:hover:after,\n        &.selected:after {\n          border-color: var(--bs-secondary);\n        }\n      }\n    }\n  }\n  .VirtualTable-Select,\n  .VirtualTable-Expand {\n    background-color: #fff;\n    input[type='checkbox'] {\n      transform: scale(1.25);\n      box-shadow: none !important;\n      background-color: transparent !important;\n      border: 0 !important;\n      overflow: visible;\n      --bs-form-check-bg-image: transparent;\n      &:before {\n        position: absolute;\n        margin: 1px 0 0 0;\n        font-family: 'Skyvibe-Icon-Font-Set' !important;\n        speak: never;\n        font-style: normal;\n        font-weight: normal;\n        font-variant: normal;\n        text-transform: none;\n        line-height: 1;\n        -webkit-font-smoothing: antialiased;\n        font-size: 1rem;\n      }\n      &:checked {\n        &:before {\n          color: #fff;\n          background-color: var(--bs-warning);\n        }\n      }\n      &:disabled {\n        &:before {\n          opacity: 0.65;\n        }\n      }\n    }\n  }\n  .VirtualTable-Select {\n    input[type='checkbox'] {\n      &:not(:checked) {\n        &:before {\n          content: '\\e98d';\n        }\n      }\n      &:checked {\n        &:before {\n          content: '\\e934';\n          padding: 0.25rem;\n          font-size: 0.5rem;\n          border-radius: 2px;\n          font-weight: 900;\n        }\n      }\n    }\n  }\n  .VirtualTable-Expand {\n    input[type='checkbox'] {\n      &:not(:checked) {\n        &:before {\n          content: '\\e98e';\n        }\n      }\n      &:checked {\n        &:before {\n          content: '\\e98f';\n        }\n      }\n    }\n  }\n  .VirtualTable-Controls {\n    position: absolute;\n    top: 1rem;\n    right: -3.25rem;\n    height: calc(100% - 2rem);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    z-index: 1;\n    i {\n      transform: scale(1.25);\n    }\n  }\n  .VirtualTable-Row:not(.HEADER) {\n    &.DEP {\n      background-color: var(--vt-row-color-dep);\n    }\n    &.ARR {\n      background-color: var(--vt-row-color-arr);\n    }\n    &.LATE {\n      background-color: var(--vt-row-color-late);\n    }\n    &.LATE.ARR.CURRENT {\n      background-color: var(--vt-row-color-late-arr);\n    }\n    &.SPL {\n      background-color: var(--vt-row-color-spl);\n    }\n    &.DELETED {\n      background-color: var(--vt-row-color-deleted);\n      &:before {\n        content: '';\n        width: calc(100% - 8px);\n        height: 0.31rem;\n        background-color: var(--bs-secondary-subtle);\n        opacity: 0.8;\n        position: absolute;\n        top: calc(50% - 0.155rem);\n        left: 4px;\n        z-index: 1;\n      }\n    }\n    &.DEP.UPCOMING:not(.DELETED, .CANCELLED, .COMPLETED) {\n      .UNASSIGNED {\n        animation: pulse 1s ease-in-out infinite !important;\n      }\n    }\n    &.CANCELLED {\n      background-color: var(--vt-row-color-cancelled);\n    }\n    &.CURBSIDE {\n      background-color: var(--vt-row-color-curbside);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
